import { Component, OnInit, Input } from "@angular/core";
import { ClassroomAttendanceService } from "../classroomAttendance.service";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { IncidentService } from "./incident.service";

@Component({
	selector: "caass-classroom-classroomAttendance-Incident",
	templateUrl: "./Incident.component.html",
})
export class ClassroomAttendanceIncidentComponent {
	@Input()
	personid: any;
	@Input()
	schoolid: any;
	infractionList: any = [];
	penaltyList: any = [];
	showDate = false;
	isSaving = false;
	ConfirmSubmitted = false;

	/*
  PersonID: any;
  StartDate: any;
  EndDate: any;
  ContinueAlert: any;
  SchoolID: any;
  DayCount: any;
  IsUseDayCount: any;
  not needed for now
  */

	incident: any = {
		InfractionID: 0,
		PenaltyID: 0,
		ContinueAlert: false,
		DayCount: 0,
	};

	constructor(private incidentService: IncidentService, private classroomService: ClassroomAttendanceService) {}

	ngOnInit() {
		this.incident.SchoolID = this.schoolid;
		this.incident.PersonID = this.personid;
		this.InfractionGetList();
	}

	cancelClick() {
		this.classroomService.cancelEdit();
	}
	private InfractionGetList() {
		var result = this.incidentService.InfractionGetList(this.schoolid);

		result.subscribe(
			(response: any) => {
				this.infractionList = response;
				if (this.infractionList.length > 1) {
					this.infractionList.unshift({
						InfractionId: 0,
						InfractionDesc: "Choose Infraction",
					});
					if (this.infractionList.length > 0) {
						this.incident.InfractionID = this.infractionList[0].InfractionId;
					}
				}
			},
			(error) => {}
		);
	}
	onInfractionChange(newInfractionID) {
		this.incident.InfractionID = newInfractionID;
		this.PenaltyGetList();
	}

	private PenaltyGetList() {
		var result = this.incidentService.PenaltyGetList(this.schoolid);

		result.subscribe(
			(response: any) => {
				this.penaltyList = response;
				this.penaltyList.unshift({});
				JSON.stringify(this.penaltyList);
			},
			(error) => {}
		);
	}

	onPenaltyChange(newPenaltyID) {
		this.incident.PenaltyID = newPenaltyID;
		var selectedAction = this.penaltyList.filter((a) => {
			return a.PenaltyID == newPenaltyID;
		});
		//MinDurationDayCount
		var action = selectedAction[0];

		if (action.MinDurationDayCount > 0) {
			this.showDate = true;
		} else {
			this.showDate = false;
		}
	}
	FadeOutLink1() {
		setTimeout(() => {
			this.ConfirmSubmitted = false;
			this.cancelClick();
		}, 3000);
	}

	onSubmitClick() {
		var result = this.incidentService.IncidentSave(this.incident);
		this.isSaving = true;
		this.ConfirmSubmitted = false;
		result.subscribe(
			(response: any) => {
				this.isSaving = false;
				this.ConfirmSubmitted = true;
				this.FadeOutLink1();

				// alert(this.studentPicture);
			},
			(error) => {
				alert("Error, Please try again or call support !!");
			}
		);
	}
}
